import { render, staticRenderFns } from "./vFormIndex.vue?vue&type=template&id=60f84acb&scoped=true&"
import script from "./vFormIndex.vue?vue&type=script&lang=js&"
export * from "./vFormIndex.vue?vue&type=script&lang=js&"
import style0 from "./vFormIndex.vue?vue&type=style&index=0&id=60f84acb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f84acb",
  null
  
)

export default component.exports